module.exports = __webpack_public_path__ + "static/media/Asset 3.7b0dd5bd.svg";